import { render, staticRenderFns } from "./ElementsQuestionPreview.vue?vue&type=template&id=5a5904fd"
import script from "./ElementsQuestionPreview.vue?vue&type=script&lang=js"
export * from "./ElementsQuestionPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports